module.exports = __webpack_public_path__ + "static/media/badge-header.973f5842.svg";